import { Block, palette, SvgIcon, spacing, Typography, useBreakpoints } from "@stepapp/ui";
import React from "react";
import { useTranslation } from "react-i18next";
import { StyleSheet } from "react-native";

const Stepcover = () => {
  const { t } = useTranslation();
  const { md } = useBreakpoints();

  const stepcoverItems = [
    t("screens.category.easyOnlineBooking"),
    t("screens.category.liabilityInsurance"),
    t("screens.category.trainedProfessionals"),
  ];

  return (
    <Block marginTop={md ? 2 : 4} style={styles.container}>
      <SvgIcon name="stepcover" size={24} />
      {stepcoverItems.map((item) => (
        <Block row alignCenter key={item} marginTop={2}>
          <SvgIcon name="checkmark" size={22} color={palette.common.black} />
          <Typography variant="paragraph" style={styles.text}>
            {item}
          </Typography>
        </Block>
      ))}
    </Block>
  );
};

export default React.memo(Stepcover);

const styles = StyleSheet.create({
  container: {
    borderWidth: 1,
    borderColor: palette.common.disabled,
    borderRadius: spacing.radius,
    paddingHorizontal: spacing.unit * 3,
    paddingVertical: spacing.unit * 2.5,
  },
  text: {
    marginLeft: spacing.unit,
  },
});
